import { ChangedHistoryModel } from './changed-history';
import { PaymentHistoryModel } from './payment-history';

export class DepositModel {
    public createdBy!: any;
    public createdDate!: string;
    public curentCNYVN!: any;
    public dathangID!: any;
    public depositCode!: string;
    public feeShipCN!: any;
    public feeShipVND!: any;
    public weightPrice!: any;
    public feeWeight!: any;
    public feeWeightCK!: any;
    public id!: number;
    public isChangeWeightByAdmin!: any;
    public isFeeShip!: any;
    public isCheck!: boolean;
    public isFragileGoods!: boolean;
    public chinaStoreID!: any;
    public orderWeight!: number;
    public orderWeightRound!: number;
    public payment!: number;
    public guaranteeAmount!: number;
    public guaranteeAmountVND!: number;
    public surcharge!: number;
    public feeOther!: number;
    public feeOtherNote!: string;
    public fragileFee!: number;
    public fragileFeeVND!: number;
    public checkFeeType!: number;
    public checkFee!: number;
    public checkFeeVND!: number;
    public receivePlaceID!: number;
    public salerID!: number;
    public status!: number;
    public statusDetail!: any;
    public totalPriceVND!: number;
    public discountVND!: number;
    public uId!: number;
    public updateDateWeightByAdmin!: any;
    public userName!: string;
    public feeShipType!: number;
    public storeVNImDate!: string;
    public storeVNExDate!: string;
    public isChecked!: boolean;
    
    public changedHistories!: ChangedHistoryModel[];
    public paymentHistory!: PaymentHistoryModel[];
};